import { Colors } from '../../theme';
import { ChipVariant } from '../types';

export const TEXT_COLORS: Record<ChipVariant, Colors> = {
  blue: Colors.blue600,
  red: Colors.red600,
  yellow: Colors.yellow700,
  green: Colors.green700,
  gray: Colors.gray900,
  orange: Colors.orange700,
  turquoise: Colors.turquoise700,
  purple: Colors.purple800,
  pink: Colors.pink800,
  violet: Colors.violet800,
};

export const BG_COLORS: Record<ChipVariant, Colors> = {
  blue: Colors.blue200,
  red: Colors.red200,
  yellow: Colors.yellow200,
  green: Colors.green200,
  gray: Colors.gray200,
  orange: Colors.orange200,
  turquoise: Colors.turquoise300,
  purple: Colors.purple200,
  pink: Colors.pink200,
  violet: Colors.violet200,
};
